<template>
  <div class="cover">
    <div class="wrapper">
      <header>
        <h1 class="logo" :style="{ backgroundImage: `url('${logo}')` }">ProDemos</h1>
        <h2 class="toolname">{{ name }}</h2>
      </header>

      <div class="description" v-html="description"></div>

      <a class="start" @click="start">Start</a>

      <a href="./download.zip" download class="download">
        Klik hier om de tool te downloaden voor offline gebruik
      </a>
    </div>
  </div>
</template>

<script>
  import { gsap } from "gsap";
  export default {
    name: "Cover",

    props: {
      name: {
        type: String,
        default: () => "",
      },
      description: {
        type: String,
        default: () => "",
      },
    },

    data() {
      return {
        baseUrl: process.env.BASE_URL,
      };
    },
    computed: {
      logo() {
        return this.baseUrl + "assets/branding/logo/logo.svg";
      },
    },
    methods: {
      start() {
        gsap.to(this.$el, { duration: 0.7, opacity: 0, display: "none", ease: "sine.easeInOut" });
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .cover {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    background-color: $cerulean-x-dark;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }

  .wrapper {
    padding: 50px;
    text-align: center;
  }

  header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 70px;
  }

  .logo {
    @include shadow(15px, $flamingo, "sw");
    width: 260px;
    height: 90px;
    background-color: $cerulean;
    text-indent: -100000px;
    //background-image: url('~assets/branding/logo/logo.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 70%;
  }

  .toolname {
    font-family: $bree-serif;
    font-size: 50px;
    margin-left: 40px;
  }

  .description {
    text-align: left;
    max-width: 1000px;
    margin: 0 auto 20px;
    li {
      list-style-type: initial;
    }
  }

  .start {
    max-width: 500px;
    //padding: 10px 50px;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 0.01em;
    display: inline-block;

    &:hover {
      color: $flamingo;
    }
  }

  .download {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    padding: 15px 20px;
    background-color: rgba(0, 0, 0, 0.1);
    width: 100%;
    font-size: 14px;
    transition: background 0.3s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
</style>
